import {useState, useEffect} from 'react'

function useWindowSize() {
  function getWindowSize() {
    return {width: window.innerWidth, height: window.innerHeight}
  }

  const [size, setSize] = useState(getWindowSize())

  useEffect(() => {
    const handleResize = () => setSize(getWindowSize())
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return size
}

export default useWindowSize
